<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        @if (success_msg !== '') {
        <div class="alert alert-green">
          <span>{{ success_msg }}</span>
        </div>
        }

        <div class="card">
          <div class="card-header card-header-danger">
            <h4 class="card-title">Orders Basic Details</h4>
            <!-- Shipping labels: one per merchant parcel (Singapore and US orders). -->
            <button mat-stroked-button class="print-labels" (click)="printLabels()">
              <mat-icon>print</mat-icon>
              Print labels
            </button>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th class="text-primary">Order-ID</th>
                    <th># {{ id }}</th>
                    <th class="text-primary">Customer Name</th>
                    <th class="text-capitalize">{{ customer_name }}</th>
                  </tr>
                  <tr>
                    <th class="text-primary">Shipping Address</th>
                    <th>{{ shipping_address }}</th>
                    <th class="text-primary">Billing Address</th>
                    <th>{{ billing_address }}</th>
                  </tr>
                  <tr>
                    <th class="text-primary">Shipping Email</th>
                    <th>{{ shipping_email }}</th>
                    <th class="text-primary">Billing Email</th>
                    <th>{{ billing_email }}</th>
                  </tr>
                  <tr>
                    <th class="text-primary">Customer Phone Number</th>
                    <th>{{ customer_phone || '—' }}</th>
                    <th></th>
                    <th></th>
                  </tr>
                  <tr>
                    <th class="text-primary">Order Currency</th>
                    <th>{{ currency }}</th>
                    <th class="text-primary">Sub Total</th>
                    <th>{{ currency }} {{ sub_total | number : '1.2-2' }}</th>
                  </tr>
                  <tr>
                    <th class="text-primary">Offer Code</th>
                    <th>{{ offerCode || '—' }}</th>
                    <th class="text-primary">Shipping Total</th>
                    <th>{{ currency }} {{ shipping_total | number : '1.2-2' }}</th>
                  </tr>
                  <tr>
                    <th class="text-primary">Subtotal Discount</th>
                    <th>{{ currency }} {{ subtotalDiscount | number : '1.2-2' }}</th>
                    <th class="text-primary">Delivery Discount</th>
                    <th>{{ currency }} {{ deliveryDiscount | number : '1.2-2' }}</th>
                  </tr>
                  <tr>
                    <th class="text-primary">Combined Discount</th>
                    <th>
                      {{ currency }} {{ subtotalDeliveryDiscount | number : '1.2-2' }}
                    </th>
                    <th class="text-primary">DTM</th>
                    <th>{{ currency }} {{ dtm || 0 | number : '1.2-2' }}</th>
                  </tr>
                  <tr>
                    <th class="text-primary">Total</th>
                    <th>{{ currency }} {{ total | number : '1.2-2' }}</th>
                    <th></th>
                    <th></th>
                  </tr>
                  <tr>
                    <th class="text-primary" scope="row">Payment Status</th>
                    <th
                      scope="row"
                      class=" payment_status-{{
                        payment_status
                      }} text-capitalize"
                    >
                      {{ payment_status }}
                    </th>
                    <th class="text-primary" scope="row">Order Status</th>
                    @if (orderStatus === 'in_progress') {
                    <th scope="row">
                      <button
                        mat-raised-button
                        type="button"
                        (click)="order_status('confirmed')"
                        [disabled]="button_disabled"
                        class="btn btn-success"
                      >
                        Confirm</button
                      >&nbsp;&nbsp;
                      <button
                        mat-raised-button
                        type="button"
                        (click)="cancelShowPopup()"
                        [disabled]="button_disabled"
                        class="btn btn-warning"
                      >
                        Cancel
                      </button>
                      @if (error_msg !== '') {
                      <span style="color: red; font-size: 14px"
                        >&nbsp;{{ error_msg }}</span
                      >
                      }
                    </th>
                    } @if (orderStatus !== 'in_progress') {
                    <th
                      scope="row"
                      class="orderStatus-{{
                        orderStatus
                      }} text-capitalize"
                    >
                      {{ orderStatus }} &nbsp;&nbsp; @if
                      (orderStatus === 'cancelled') {
                      <span
                        style="color: blue; cursor: pointer"
                        role="button"
                        tabindex="0"
                        (click)="cancelShowPopup()"
                        (keyup.enter)="cancelShowPopup()"
                        (keyup.space)="cancelShowPopup()"
                        >show reason</span
                      >
                      }
                    </th>
                    }
                  </tr>
                  <tr>
                    <th class="text-primary">Order On</th>
                    <th>{{ created_on | date : 'medium' }}</th>
                    <th class="text-primary">Update On</th>
                    <th>{{ updated_on | date : 'medium' }}</th>
                  </tr>
                  <tr>
                    <th class="text-primary">Admin Notes</th>
                    <th>
                      <div class="editable-field">
                        <textarea
                          [(ngModel)]="adminNotes"
                          rows="2"
                          class="notes-textarea"
                          placeholder="Add admin notes..."
                        ></textarea>
                        <button
                          mat-icon-button
                          color="primary"
                          (click)="saveAdminNotes()"
                          matTooltip="Save admin notes"
                          class="save-btn"
                        >
                          <mat-icon>save</mat-icon>
                        </button>
                      </div>
                    </th>
                    <th class="text-primary">Customer Remarks</th>
                    <th>
                      <div class="editable-field">
                        <textarea
                          [(ngModel)]="remarks"
                          rows="2"
                          class="notes-textarea"
                          placeholder="Add customer remarks..."
                        ></textarea>
                        <button
                          mat-icon-button
                          color="primary"
                          (click)="saveRemarks()"
                          matTooltip="Save remarks"
                          class="save-btn"
                        >
                          <mat-icon>save</mat-icon>
                        </button>
                      </div>
                    </th>
                  </tr>
                  <!-- Each merchant's note to the customer, shown on the customer's
                       My Orders; the merchant writes it on the merchant portal. -->
                  @if (merchantRemarks.length) {
                    <tr>
                      <th class="text-primary">Merchant Remarks for Customer</th>
                      <th colspan="3">
                        @for (m of merchantRemarks; track m.vendor_id) {
                          @if (merchantRemarks.length > 1) {
                            <div class="merchant-remarks-name">{{ m.vendor_name || 'Merchant ' + m.vendor_id }}</div>
                          }
                          <div class="editable-field">
                            <textarea
                              [(ngModel)]="m.remarks"
                              rows="2"
                              maxlength="500"
                              class="notes-textarea"
                              placeholder="Write updates for customers including delivery updates or delivery tracking number"
                            ></textarea>
                            <button
                              mat-icon-button
                              color="primary"
                              [disabled]="savingMerchantRemarks.has(m.vendor_id)"
                              (click)="saveMerchantRemarks(m)"
                              matTooltip="Save merchant remarks"
                              class="save-btn"
                            >
                              <mat-icon>save</mat-icon>
                            </button>
                          </div>
                          <div class="merchant-remarks-count">{{ (m.remarks || '').length }}/500</div>
                        }
                      </th>
                    </tr>
                  }
                </thead>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h4 class="card-title">Orders Details (Product List)</h4>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table">
                <thead class="text-primary">
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Img</th>
                    <th>Sub Total</th>
                    <th>Ship</th>
                    <th>Total DTM</th>
                    <th>Option/OrigPrc/WithDTM</th>
                    <th>Qty</th>
                    <th>Vendor</th>
                    <th>Delivery Status</th>
                    <th>Item Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  @for (row of list; track row) {
                  <tr>
                    <td>{{ row.product_id }}</td>
                    <td class="text-capitalize">{{ row.product_name }}</td>
                    <td>
                      @if (row.product_image) {
                      <img
                        src="{{ row.product_image }}"
                        alt="Product Image"
                        width="80"
                        height="80"
                      />
                      }
                    </td>
                    <td>
                      {{ currency }}
                      {{ row.productTotalPrice | number : '1.2-2' }}
                    </td>
                    <td>
                      {{ currency }} {{ row.delivery_price | number : '1.2-2' }}
                    </td>
                    <td>
                      {{ currency }}
                      {{
                        row.totalDestinationTranshipperMarkup || 0
                          | number : '1.2-2'
                      }}
                    </td>
                    <td>
                      {{ row.addon_name }} / {{ currency }}
                      {{ row.priceWithoutDtm | number : '1.2-2' }} /
                      {{ row.final_price | number : '1.2-2' }}
                    </td>
                    <td>{{ row.quantity }}</td>
                    <td class="text-capitalize">
                      {{ row.vendor_name }}
                      <button
                        mat-icon-button
                        class="vendor-label"
                        matTooltip="Print this merchant's shipping label"
                        (click)="printLabels(row.vendor_id)"
                      >
                        <mat-icon>print</mat-icon>
                      </button>
                    </td>
                    <td>
                      <fh-form-autocomplete
                        [options]="deliveryStatusOptions"
                        label=""
                        [(ngModel)]="row.delivery_status"
                        (ngModelChange)="updateItemDeliveryStatus(row)"
                      />
                    </td>
                    <td>
                      <input [(ngModel)]="row.remarks" />
                      <button mat-icon-button (click)="updateItemRemarks(row)">
                        <span>✓</span>
                      </button>
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
